import {track} from "@amplitude/analytics-browser";
import {Space, Spoiler as SpoilerComponent} from "@mantine/core";
import React from "react";

import classes from "./Spoiler.module.scss";

export interface SpoilerProps {
  label?: string | null;
  maxHeight?: number;
  children: React.ReactNode;
}

export default function Spoiler({
  label = "Continue reading...",
  maxHeight = 306,
  children,
}: SpoilerProps) {
  return (
    <>
      <SpoilerComponent
        classNames={{
          root: classes.spoiler,
          content: classes.content,
          control: classes.control,
        }}
        maxHeight={maxHeight}
        showLabel={label}
        hideLabel=""
        transitionDuration={500}
        onExpandedChange={expanded => {
          if (expanded) {
            track("Continue Reading Clicked");
          }
        }}>
        {children}
      </SpoilerComponent>
      <Space h="sm" />
    </>
  );
}
